import React from "react";
import { Skeleton } from "antd5";
import { Flex } from "styles/utility-components";

import { INLINE_FILTERS, useVariableValue } from "lib/featureFlags";
import { ListNewSavedViewsResponse, PinnedSavedViewDto } from "lib/generated/app-api";
import { SavedViewType } from "../saved_views_bar/types";
import { useMyFeedPageState } from "../useMyFeedPageState";
import PinnedViewsList from "./PinnedViewsList";
import { NoViewHeaderText, ViewHeaderText } from "./ViewHeaderText";

const filteredAllViews = (
  allViews: ListNewSavedViewsResponse["savedViews"],
  pinnedViews: PinnedSavedViewDto[],
) => {
  const pinnedView = pinnedViews.map((view) => allViews.find((v) => v.id === view.savedViewId));
  return pinnedView.filter((view) => view !== undefined) as SavedViewType[];
};

function ViewsContainer() {
  const { allViews, pinnedViews, selectedView, isLoadingViews } = useMyFeedPageState();
  const isInlineFiltersEnabled = useVariableValue(INLINE_FILTERS, false);

  if (isLoadingViews) {
    return <Skeleton />;
  }

  if (!allViews || !pinnedViews) {
    return null;
  }

  return (
    <Flex column gap="16px">
      {selectedView ? (
        <ViewHeaderText view={selectedView} pinnedViews={filteredAllViews(allViews, pinnedViews)} />
      ) : (
        <NoViewHeaderText pinnedViews={filteredAllViews(allViews, pinnedViews)} />
      )}
      {!isInlineFiltersEnabled && (
        <PinnedViewsList pinnedViews={filteredAllViews(allViews, pinnedViews)} />
      )}
    </Flex>
  );
}

export default ViewsContainer;
